export default __webpack_public_path__ + "static/media/building.f76adc78.svg";